import { PROTECTED_PATHS } from '../../app/constants';
import { RiCameraLensLine } from 'react-icons/ri';
import { BiWallet } from 'react-icons/bi';
import { BsHouse, BsGear, BsPeople } from 'react-icons/bs';
// import { FaPeopleArrows } from 'react-icons/fa';
import { IoIosNotificationsOutline } from 'react-icons/io';
import { VscPerson } from 'react-icons/vsc';
import { FcAdvertising } from 'react-icons/fc';
import { FaShopify } from 'react-icons/fa';
import { MdHowToVote } from 'react-icons/md';

// const {
//   MY_ESTATE,
//   MY_WALLET,
//   // MY_ERRANDS,
//   NOTIFICATIONS,
//   // NEWS_EVENTS,
//   ISSUE_REPORT,
//   // EMERGENCY,
//   GUEST_LIST,
//   SETTINGS,
//   POST_ADVERT,
//   SPECIAL_GUEST_REQUEST,
//   SHOP,

// } = PROTECTED_PATHS;

export const NAV_ITEMS = [
  {
    title: 'My Estate',
    to: PROTECTED_PATHS.MY_ESTATE,
    icon: <BsHouse size={20} />,
  },
  {
    title: 'My Wallet',
    to: PROTECTED_PATHS.MY_WALLET,
    icon: <BiWallet size={20} />,
  },
  // {
  //   title: 'My Errands',
  //   to: MY_ERRANDS,
  //   icon: <FaPeopleArrows size={18} />,
  // },

  {
    title: 'Post Advert',
    to: PROTECTED_PATHS.POST_ADVERT,
    icon: <FcAdvertising size={25} />,
  },
  {
    title: 'My Shop',
    to: PROTECTED_PATHS.SHOP,
    icon: <FaShopify size={22} />,
  },
  // {
  //   title: 'News/Events',
  //   to: NEWS_EVENTS,
  //   icon: <BsCalendarEvent size={17} />,
  // },
  {
    title: 'Guest List',
    to: PROTECTED_PATHS.GUEST_LIST,
    icon: <VscPerson size={25} />,
  },
  {
    title: 'Special Request',
    to: PROTECTED_PATHS.SPECIAL_GUEST_REQUEST,
    icon: <BsPeople size={22} />,
  },
  {
    title: 'Notifications',
    to: PROTECTED_PATHS.NOTIFICATIONS,
    icon: <IoIosNotificationsOutline size={22} />,
  },
  {
    title: 'Issue report',
    to: PROTECTED_PATHS.ISSUE_REPORT,
    icon: <RiCameraLensLine size={20} />,
  },
  {
    title: 'Polls',
    to: PROTECTED_PATHS.POLLS,
    icon: <MdHowToVote size={20} />,
  },

  {
    title: 'Settings',
    to: PROTECTED_PATHS.SETTINGS,
    icon: <BsGear size={20} />,
  },
];
